module.exports = __webpack_public_path__ + "img/android.b17dccd7.svg";